import { render, staticRenderFns } from "./mistake.vue?vue&type=template&id=26e16a68&scoped=true&"
import script from "./mistake.vue?vue&type=script&lang=js&"
export * from "./mistake.vue?vue&type=script&lang=js&"
import style0 from "./mistake.vue?vue&type=style&index=0&id=26e16a68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26e16a68",
  null
  
)

export default component.exports